/* eslint-disable max-len */
export default [
  {
    title: 'Grass Seed Calculator',
    description: 'When you\'re ready to seed your lawn, our calculator helps you estimate the amount of grass seed you\'ll need to get the job done.',
    link: 'https://www.homedepot.com/account/view/calculator/grassseed',
    imageUrl: 'https://dam.thdstatic.com/content/production/IsDbgp2OY0B3umiEWfJMZw/4bBX9FZan7NV5hNvbieZ8g/Original file/17OCT23_LawnCare_Resources_01.png?im=Crop,rect=(500,189.54527243589746,1000.0000000000001,562.5);Resize=(703,395.44)',
  },
  {
    title: 'Mulch Calculator',
    description: 'Enter your preferred material, the square footage and mulch depth of the coverage space for accurate results.',
    link: 'https://www.homedepot.com/calculator/mulch',
    imageUrl: 'https://dam.thdstatic.com/content/production/CRnR12z_RRtVS8iv3cdglA/Fnr2V_d6r5a9JBHDYXepxw/Original%20file/shutterstock_355460.jpg?im=Crop,rect=(3.3671875,92.0234375,991.4453125,557.68798828125);Resize=(703,395.44)',
  },
  {
    title: 'Fencing Calculator',
    description: 'We\'ll calculate the amount of fencing you should purchase based on your property needs.',
    link: 'https://www.homedepot.com/project-seller/fencing-calculator',
    imageUrl: 'https://dam.thdstatic.com/content/production/y8XLouqYzG7JLN76R37CvA/7nKpebA2LkmdbVXZa7csmg/Original%20file/b3f597e1-e5c4-42e6-84a0-5079b9bfe25a_73012319_4ft._x_8ft._Ohio_Closed_Picket.jpeg?im=Crop,rect=(0,159.54527243589746,1000.0000000000001,562.5);Resize=(703,395.44)',
  },
];